module.exports = __webpack_public_path__ + "static/img/054_TO8_1595_og.ecaf0f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/054_TO8_1595_og.jpg
// module id = UbRs
// module chunks = 0